import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useToast} from "@chakra-ui/react";
import {Award, Bookmark, CircleMinus, Flag, Link, UserRoundMinus, Vote} from "lucide-react";
import {useLoggedIn, useStorePost, useStoreProfile} from "../../store";
import useModal from "../../modals";
import useFeedback from "../../utils/use_feedback";
import {useHidePost} from "../../api/post";
import {useBlock} from "../../api/user";
import pluralize from "../../utils/pluralize";
import {useSheetModal} from "../test/ModalContext";
import {useActions} from "../../app_context";
import ReportSheet from "./report";
import AwardSheet from "./award/give_award";
import Sheet, {MenuItem, MenuItemIcon, MenuItemText} from './sheet';
import SignupPromptSheet from "./signup_prompt";
import SaveSheet from "./save";

const PostActionsSheet = styled(({className, postId, isTrending, save, onClose}) => {

    const { openModal } = useSheetModal();
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const toast = useToast();
    const {post} = useStorePost(postId);
    const {feedbackCh} = useFeedback(true);
    const hidePost = useHidePost(feedbackCh);
    const block = useBlock(feedbackCh);
    const handleBlockUser = async () => {
        onClose();
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            try {
                await block(post.author);
                toast({
                    title: `Blocked user!`,
                    status: 'success',
                    isClosable: true,
                });
            } catch {
                toast({
                    title: `Failed to block.`,
                    status: 'error',
                    isClosable: true,
                });
            }
        }
    };
    const actions = useActions();
    const {blocked_communities} = useStoreProfile();
    const handleBlockCommunity = async () => {
        await actions.settingsChanged({blocked_communities: [...blocked_communities || [], post?.community]});
        onClose();
    };
    const handleHide = async () => {
        onClose();
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            try {
                await hidePost(post);
            } catch {
                toast({
                    title: `Failed to hide.`,
                    status: 'error',
                    isClosable: true,
                });
            }
        }
    };
    const handleVoteBreakdown = () => {
        onClose();
        toast({
            title: `Score breakdown:`,
            description: `${pluralize(post.score_up, 'upvote')} / ${pluralize(post.score_down, 'downvote')}`,
            status: 'info',
            isClosable: true,
        });
    };

    const handleCopy = () => {
        onClose();
        navigator.clipboard.writeText(`https://${window.location.hostname}/c/${post.community}/p/${post.uuid}/`);
    };

    const handleReport = () => {
        if (!loggedIn) {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() }  padding={"header"}><ReportSheet community={post?.community} isPost id={postId} onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const handleAward = () => {
        if (!loggedIn) {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() }  padding={"header"}><AwardSheet id={post.id} type={'post'} onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const handleSave = () => {
        if (!loggedIn) {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SaveSheet post={post} onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    return (
        <div className={className}>
            <MenuItem onClick={handleAward}>
                <MenuItemIcon>
                    <Award size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Award
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleReport}>
                <MenuItemIcon>
                    <Flag size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Report
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleBlockUser}>
                <MenuItemIcon>
                    <UserRoundMinus size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Block User
                </MenuItemText>
            </MenuItem>
            {save &&
                <MenuItem onClick={handleSave}>
                    <MenuItemIcon>
                        <Bookmark size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Save
                    </MenuItemText>
                </MenuItem>
            }
            {isTrending &&
                <MenuItem onClick={handleBlockCommunity}>
                    <MenuItemIcon>
                        <CircleMinus size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Block Community
                    </MenuItemText>
                </MenuItem>
            }
            <MenuItem onClick={handleVoteBreakdown}>
                <MenuItemIcon>
                    <Vote size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Vote Details
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleCopy}>
                <MenuItemIcon>
                    <Link size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Copy Link
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default PostActionsSheet;
